import { get } from 'lodash';

export function parseDynamicFieldsSimple(
  formContext: any,
  params?: any,
): any | undefined {
  const dynamicFieldChecker = /^\${1}\{{2}\s*[a-zA-Z0-9_\-]+\s*\}{2}$/g;
  const dynamicFieldExtractor = /[\$\{\}\s]/g;

  if (Array.isArray(params)) {
    return params
      .map(value => parseDynamicFieldsSimple(formContext, value))
      .filter(val => val !== undefined);
  }

  if (typeof params === 'string' && dynamicFieldChecker.test(params)) {
    const fieldName = params.replaceAll(dynamicFieldExtractor, '');
    return get(formContext, fieldName);
  }

  if (typeof params === 'object' && params !== null) {
    return Object.entries(params).reduce((acc, [key, value]) => {
      acc[key] = parseDynamicFieldsSimple(formContext, value);
      return acc;
    }, {} as any);
  }

  return params;
}

export const cleanParams = (params: Record<string, any>) => {
  Object.keys(params).forEach(key => {
    const val = params[key];
    if (
      val === undefined ||
      val === null ||
      (typeof val === 'string' && String(val).trim() === '')
    ) {
      delete params[key];
    }
  });
};
